const productListConfig = [
  [{
    'active': false,
    'planTit': 'Load Board-Carrier',
    'planInfo': 'Access to real-time load updates, unlimited searching, find best paying loads, premium features: rate check, save hide shipper, broker credit, and days - to - pay information.',
  }],
  [{
    'active': false,
    'planTit': 'Truckloads Diamond Membership',
    'planInfo': 'Have the advantage when negotiating with a shipper or broker by unlocking the Average Truckloads Rate and Fuel Surcharge Calculator feature.',
  }],
  [{
    'active': false,
    'planTit': 'Truckloads Diamond Membership',
    'planInfo': 'Have the advantage when negotiating with a shipper or broker by unlocking the Average Truckloads Rate and Fuel Surcharge Calculator feature.',
  }],
];
const planModesConfig = [
  {
    package: 'Monthly',
    originPrice: '$M',
    currentPrice: '$M',
    saveover: '',
    checked: true,
  },
  {
    package: 'Quarterly',
    originPrice: '$M',
    currentPrice: '$M',
    saveover: '',
    checked: false,
  },
  {
    package: 'Annually',
    originPrice: '$M',
    currentPrice: '$M',
    saveover: '',
    checked: false,
  },
];
export {productListConfig, planModesConfig};



// WEBPACK FOOTER //
// ./src/components/pages/PaymentProcess/BasicInformation/config.js